import React, {useContext, useEffect, useRef, useState} from 'react';
import {Toast} from "primereact/toast";
import {Button} from "primereact/button";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Dialog} from "primereact/dialog";
import {confirmPopup, ConfirmPopup} from "primereact/confirmpopup";
import {Dropdown} from "primereact/dropdown";
import {LayoutContext} from "../../../../../../layout/context/LayoutContext";
import {usePagination} from "../../../../../../layout/hooks/usePagination";
import callToast, {
    handleChangeData,
    handleDelete,
    mergeWithSelected,
    postData,
    validateFormFields
} from "../../../../../../utils/helper";
import {useFetch} from "../../../../../../layout/hooks/useFetch";
import {webInfo} from "../../../../../../utils/webInfo";
import PageHeading from "../../../../../../Components/PageHeading";
import Label from "../../../../../../Components/Label";


interface InitialState {
    vehicle_id: { id: number, model: string, serial_number:string } | null,
    vehicle_tracking_device_id: { id: number, sl_number: string, model: string, protocol: string } | null,
}

const DeviceMapping = () => {
    const initialState: InitialState = {
        vehicle_id: null,
        vehicle_tracking_device_id: null
    };
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);
    const {accessToken} = useContext(LayoutContext)
    const [refresh, setRefresh] = useState<boolean>(false);
    const [formData, setFormData] = useState<InitialState>(initialState);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    const toast = useRef<Toast | null>(null)
    const deleteId = useRef<number>(0)

    const [modal, setModal] = useState<boolean>(false);
    const [updatedId, setUpdatedId] = useState<number | null>(null);

    const [vehicleNameFilter, setVehicleNameFilter] = useState<string>('');
    const [vehicleOptions, setVehicleOptions] = useState<{ id: number, model: string, serial_number:string }[]>([]);

    const [deviceFilter, setDeviceFilter] = useState<string>('');
    const [deviceOptions, setDeviceOptions] = useState<{ id: number, model: string, sl_number:string, protocol:string }[]>([]);



    // pagination
    const {page, limitData, handlePageChange} = usePagination();

    // endpoint
    const mainTitle = "Device Mapping"
    const tableDataEndpointUrl = `/vehicle-device-mappings?page=${page} `
    const submitFormEndpointUrl = updatedId ? `/vehicle-device-mappings/${updatedId}` : "/vehicle-device-mappings";

    const accept = () => {
        const deleteParams = {
            id: deleteId.current,
            startEndpoint: "/vehicle-device-mappings/",
            // finalEndpoint: finalEndpoint,
            name: "device mapping",
            setUpdate: setRefresh,
            token: accessToken,
            toast: toast,
        }

        handleDelete(deleteParams).then()
    }



    const {data: vehicleRawData} = useFetch(
        `/vehicle?page=1&per_page=10${vehicleNameFilter ? `&model=${vehicleNameFilter}` : ''}`,
        [vehicleNameFilter]
    );

    useEffect(() => {
        if (vehicleRawData) {
            const modifiedData = vehicleRawData?.map((item: any) => ({
                id: item?.id,
                model: item?.model,
                serial_number: item?.serial_number,
            }));
            setVehicleOptions(mergeWithSelected(modifiedData, formData?.vehicle_id));
        }
    }, [vehicleRawData, formData?.vehicle_id]);

    const {data: deviceRawData} = useFetch(
        `/vehicle-tracking-devices?page=1&per_page=10${deviceFilter ? `&model=${deviceFilter}` : ''}`,
        [deviceFilter]
    );

    useEffect(() => {
        if (deviceRawData) {
            const modifiedData = deviceRawData?.map((item: any) => ({
                id: item?.id,
                model: item?.model,
                sl_number: item?.sl_number,
                protocol:item?.protocol,
            }));
            setDeviceOptions(mergeWithSelected(modifiedData, formData?.vehicle_tracking_device_id));
        }
    }, [deviceRawData, formData?.vehicle_tracking_device_id]);






    // fetch data
    const {
        data: tableDataList,
        totalData, loading
    } = useFetch(tableDataEndpointUrl, [refresh])


    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const validationRules = [
            {field: 'vehicle_tracking_device_id', label: 'Tracking Device'},
            {field: 'vehicle_id', label: 'Vehicle'},

        ];

        if (!validateFormFields(formData, validationRules, toast)) return;

        const payload = {
            // name: formData.name.replace(/\s+/g, ' ').trim()
            vehicle_id: formData.vehicle_id?.id,
            vehicle_tracking_device_id: formData.vehicle_tracking_device_id?.id,
        };

        try {
            setIsSubmitting(true);
            const response = await fetch(`${webInfo?.baseUrl}${submitFormEndpointUrl}`, postData("PUT", accessToken, payload));

            if (response.ok) {
                callToast(toast, true, `${mainTitle} ${updatedId ? 'updated' : 'created'} successfully`);
                setFormData(initialState)
                setModal(false)
                setUpdatedId(null)
                setDeviceFilter('')
                setVehicleNameFilter('')
                setRefresh(!refresh);
                return;
            } else {
                const resData = await response.json();
                callToast(toast, false, resData.error);
            }

        } catch (err) {
            console.error('Failed to update', err);
        } finally {
            setIsSubmitting(false);
        }

    }

    // row edit template
    const actionTemplate = (rowData: any) => {
        console.log("edit row data", rowData);
        return (
            <div className={'flex align-items-center justify-content-end gap-2'}>
                <Button
                    icon={'pi pi-pencil'}
                    className={'border-rounded w-2rem h-2rem'}
                    onClick={() => {

                        setModal(true)
                        setUpdatedId(rowData?.id)
                        setDeviceFilter('')
                        setVehicleNameFilter('')
                        setFormData({

                            vehicle_id: rowData?.vehicle ? {
                                id: rowData?.vehicle?.id,
                                model: rowData?.vehicle?.model,
                                serial_number: rowData?.vehicle?.serial_number,
                            } : null,

                            vehicle_tracking_device_id: rowData?.vehicle_tracking_device ? {
                                id: rowData?.vehicle_tracking_device?.id,
                                model: rowData?.vehicle_tracking_device?.model,
                                sl_number: rowData?.vehicle_tracking_device?.sl_number,
                                protocol: rowData?.vehicle_tracking_device?.protocol,
                             } : null,

                        })
                    }}
                    outlined/>

                <Button
                    icon={'pi pi-trash'}
                    // tooltip={'Delete reservation'}
                    className={'border-rounded w-2rem h-2rem'}
                    outlined
                    onClick={(event: any) => {
                        // setDeletedFloorId(rowData?.id);
                        deleteId.current = rowData?.id;
                        confirmPopup({
                            target: event.currentTarget,
                            message: `Do you want to delete this device mapping?`,
                            // message: `Do you want to delete this ${mainTitle.toLowerCase()}`,
                            icon: 'pi pi-info-circle',
                            acceptClassName: 'p-button-danger',
                            accept,
                            onHide() {
                                deleteId.current = 0;
                            }
                        })
                    }}
                />
            </div>
        )
    }

    const vehicleInformationBodyTemplate = (rowData: any) => {
        return (
            <div className="flex flex-column">
                <span className="font-semibold text-sm text-900">{rowData?.vehicle?.model}</span>
                <span className="text-xs text-700">{rowData?.vehicle?.serial_number}</span>
            </div>
        );
    };

    const deviceInformationBodyTemplate = (rowData: any) => {
        return (
            <div className="flex flex-column">
                <span className="font-semibold text-sm text-900">{rowData?.vehicle_tracking_device?.model}</span>
                <span className="text-xs text-700">{rowData?.vehicle_tracking_device?.sl_number}</span>
                <span className="text-xs text-700">{rowData?.vehicle_tracking_device?.protocol}</span>
            </div>
        )
    }


    const formVehicleDropdownItemTemplate = (option: any) => {

        return (
            <div className="flex flex-column gap-1">
                <span className="font-semibold text-900 text-sm">{option?.model}</span>
                <span className="text-xs text-700">{option?.registration_number}</span>
            </div>
        )
    }

    const formDeviceDropdownItemTemplate = (option: any) => {
        return (
            <div className="flex flex-column gap-1">
                <span className="font-semibold text-900 text-sm">{option?.model}</span>
                <span className="text-xs text-700">{option?.sl_number}</span>
                <span className="text-xs text-700">{option?.protocol}</span>
            </div>
        )
    }



    return (
        <div className={"card"}>
            <Toast ref={toast}/>
            <ConfirmPopup/>
            <PageHeading title={mainTitle}
                         isCreate={true}
                         createFunction={() => setModal(true)}
                         back={true}
            />

            <DataTable
                value={tableDataList}
                dataKey="id"
                tableStyle={{minWidth: '50rem'}}
                paginator={tableDataList?.length > 0}
                lazy
                first={(page - 1) * limitData}
                rows={limitData}
                totalRecords={totalData}
                loading={loading}
                onPage={handlePageChange}
            >
                <Column
                    field="vehicle"
                    header="Vehicle Information"
                    body={vehicleInformationBodyTemplate}
                    style={{width: '33%'}}
                    headerClassName={"white-space-nowrap"}
                />

                <Column
                    field={"vehicle_tracking_device"}
                    header="Device Information"
                    style={{width: '33%'}}
                    body={deviceInformationBodyTemplate}
                    headerClassName={"white-space-nowrap "}
                />

                <Column
                    field={"vehicle_tracking_device.vehicle_device_vendor.name"}
                    header="Device Vendor"
                    style={{width: '33%'}}
                    headerClassName={"white-space-nowrap "}
                />

                <Column header={"Action"} rowEditor={true}
                        bodyStyle={{textAlign: 'center'}}
                        body={actionTemplate}
                        headerClassName={"flex justify-content-end"}
                />
            </DataTable>

            <Dialog visible={modal}
                    style={{width: "50rem"}}
                    headerClassName="text-800 font-semibold text-xl"
                    header={updatedId ? `Edit ${mainTitle}` : `New ${mainTitle}`}
                    breakpoints={{"960px": "75vw", "640px": "90vw"}}
                    onHide={() => {
                        setUpdatedId(null)
                        setModal(false)
                        setFormData(initialState)
                        setDeviceFilter('')
                        setVehicleNameFilter('')
                    }}
            >
                <div>
                    <form className={''}
                          onSubmit={handleSubmit}
                    >
                        <div className="grid ">
                            <div className="col-12  md:col-6">
                                <Label label={"Vehicle"} required={!updatedId}/>
                                <Dropdown
                                    options={vehicleOptions? vehicleOptions : []}
                                    optionLabel="model"
                                    id="vehicle_id"
                                    name={`vehicle_id`}
                                    className={`w-full`}
                                    value={formData?.vehicle_id}
                                    onChange={(e) => handleChangeData('vehicle_id', e.value, formData, setFormData)}
                                    placeholder="Select vehicle"
                                    filter
                                    onFilter={(e) => {
                                        if (timeoutRef?.current) {
                                            clearTimeout(timeoutRef.current);
                                        }
                                        timeoutRef.current = setTimeout(() => {
                                            setVehicleNameFilter(e.filter)
                                        }, 500);

                                        if (vehicleRawData) {
                                            const modifiedData = vehicleRawData.map((item: any) => ({
                                                id: item?.id,
                                                model: item?.model,
                                                serial_number: item?.serial_number,
                                            }));
                                            setVehicleOptions(modifiedData);
                                        }
                                    }}
                                    // valueTemplate={(option)=>option? option?.model + '-' + option?.serial_number : 'Select vehicle'}
                                    itemTemplate={formVehicleDropdownItemTemplate}
                                    showClear
                                    showFilterClear
                                />
                            </div>
                            <div className="col-12  md:col-6">
                                <Label label={"Vehicle"} required={!updatedId}/>
                                <Dropdown
                                    options={deviceOptions? deviceOptions : []}
                                    optionLabel="model"
                                    id="vehicle_tracking_device_id"
                                    name={`vehicle_tracking_device_id`}
                                    className={`w-full`}
                                    value={formData?.vehicle_tracking_device_id}
                                    onChange={(e) => handleChangeData('vehicle_tracking_device_id', e.value, formData, setFormData)}
                                    placeholder="Select device"
                                    filter
                                    onFilter={(e) => {
                                        if (timeoutRef?.current) {
                                            clearTimeout(timeoutRef.current);
                                        }
                                        timeoutRef.current = setTimeout(() => {
                                            setDeviceFilter(e.filter)
                                        }, 500);

                                        if (deviceRawData) {
                                            const modifiedData = deviceRawData.map((item: any) => ({
                                                id: item?.id,
                                                model: item?.model,
                                                sl_number: item?.sl_number,
                                                protocol:item?.protocol,
                                            }));
                                            setDeviceOptions(modifiedData);
                                        }
                                    }}
                                    // valueTemplate={(option)=>option? option?.model + '-' + option?.serial_number : 'Select vehicle'}
                                    itemTemplate={formDeviceDropdownItemTemplate}
                                    showClear
                                    showFilterClear
                                />
                            </div>

                        </div>
                        <div className="flex gap-2 mt-2">
                            <Button
                                type="submit"
                                label={updatedId ? 'Update' : "Create"}
                                className="p-button-primary"
                                loading={isSubmitting}
                                size={'small'}
                            />
                        </div>
                    </form>
                </div>
            </Dialog>

        </div>
    );
};

export default DeviceMapping;